
import { ElForm } from 'element-ui/types/form'
import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'

@Component({})
export default class Contact extends Vue {
    @Prop({ default: false }) private loading!: boolean
    @Ref('contactRef') private contactRef!: ElForm
    private DialogVisible = false
    private showCommonWords = false
    private loadingInstance: any = ''
    private contactForm = {
        content: '',
        sendType: ['sms', 'im']
    }
    private contactRules = {
        content: [
            { required: true, max: 500, min: 10, message: '请按要求输入联系内容', trigger: 'blur' }
        ],
        sendType: [
            { required: true, message: '请选择发送类型' }
        ]
    }
    get commonWords() {
        return AppModule.commonWords
    }

    @Watch('loading')
    private onLoadingChange(loading: boolean) {
        if (loading) {
            this.loadingInstance = this.$loading({
                lock: true,
                text: '发送中',
                target: '.contact .el-dialog'
            })
        } else {
            this.loadingInstance && this.loadingInstance.close()
        }
    }

    private close() {
        this.DialogVisible = false
    }

    private show() {
        this.DialogVisible = true
    }

    private onDialogOpen() {
        this.contactForm.content = ''
        this.$nextTick(() => {
            this.contactRef.clearValidate()
        })
    }

    private onDialogClosed() {
        this.contactForm.content = ''
        this.showCommonWords = false
        this.contactRef.resetFields()
    }

    private SelectWord(event: any) {
        const { target: { dataset } } = event
        if (!dataset.content) return
        this.contactForm.content = dataset.content
        this.showCommonWords = false
    }

    private onSend() {
        this.contactRef.validate((isValid: boolean) => {
            if (isValid) {
                this.$emit('send', this.contactForm)
                return
            }
        })
    }
}
